import React from "react";
import greenTick from "../../../images/green_tick.svg";
import redCross from "../../../images/cross_red.svg";
import { IMAGING_COMPLETE_LABEL } from "./imagingUtils";

export interface ImagingStatusIndicatorProps {
  status: "COMPLETE" | "INCOMPLETE" | null;
  missingDocuments?: string[];
  completeTooltip?: string;
  completeAlt?: string;
}

export const ImagingStatusIndicator: React.FC<ImagingStatusIndicatorProps> = ({
  status,
  missingDocuments = [],
  completeTooltip = IMAGING_COMPLETE_LABEL,
  completeAlt = IMAGING_COMPLETE_LABEL,
}) => {
  if (!status) return null;

  if (status === "COMPLETE") {
    return (
      <span className="manifest-imaging">
        <span className="manifest-imaging__tooltip">
          <img
            src={greenTick}
            alt={completeAlt}
            className="manifest-imaging__icon manifest-imaging__icon--complete"
          />
          <span className="manifest-imaging__tooltip-text">{completeTooltip}</span>
        </span>
      </span>
    );
  }

  return (
    <span className="manifest-imaging">
      <span className="manifest-imaging__pills">
        {missingDocuments.map((doc) => (
          <span key={doc} className="manifest-imaging__pill">
            <img
              src={redCross}
              alt="missing"
              className="manifest-imaging__icon manifest-imaging__icon--small"
            />
            <span className="manifest-imaging__pill-text">{doc}</span>
          </span>
        ))}
      </span>
    </span>
  );
};
